module.exports = __webpack_public_path__ + "img/alianza-para-el-progreso.1669dda5.png";